export default __webpack_public_path__ + "img/dAfUGlRk.cb8f0242.svg";